
<template>
  <div class="relative">
    <span
      class="iconfont icon-emo"
      @click="map.isShow = !map.isShow"
    />
    <div
      v-if="map.isShow"
      class="box emoji-box"
    >
      <div
        v-for="(item, index) in map.emojis"
        :key="index"
        class="emoji-item"
        @click="handleSelect(item)"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from 'vue'
import { emoji } from '@/assets/emoji/emoji'
export default defineComponent({
  name: 'EmojiBox',
  props: {
  },
  setup (props, { emit }) {
    const map = reactive({
      emojis: [],
      isShow: false
    })
    onMounted(() => {
      map.emojis = [...emoji]
      document.addEventListener('click', (e) => {
        if (e && e.target && e.target.className) {
          const cn = e.target.className
          if (typeof (cn) !== 'string') {
            map.isShow = false
          } else {
            if (cn.indexOf('icon-emo') === -1 &&
              cn.indexOf('emoji-box') === -1 &&
              cn.indexOf('emoji-item') === -1) {
              map.isShow = false
            }
          }
        }
      })
    })
    const handleSelect = (item) => {
      map.isShow = false
      emit('select', item)
    }
    return {
      map,
      handleSelect
    }
  }
})
</script>
<style scoped lang="scss" rel="stylesheet/scss">
.icon-emo {
  position: relative;
  top: -3px;
  font-size: 24px;
  color: #BECADB;
}
.box {
  position: absolute;
  border: 1px solid #ccc;
  box-shadow: 0 1px 10px 0 rgb(0 0 0 / 10%);
  border-radius: 4px;
  padding: 10px 10px 10px 11px;
  width: 226px;
  background: #fff;
  z-index: 200;
  div {
    margin-right: 2px;
    display: inline-block;
    cursor: pointer;
    font-size: 17px;
  }
}
</style>
